<template>
    <div class="pb-10 lg:pb-0 flex flex-col justify-center">
        <div class="p-4 mx-auto grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white space-y-6 md:space-y-0 bg-gray-200 bg-opacity-80 rounded-xl">
            <!-- first multiplier -->
            <div class="px-10">
                <div class="text-center font-extrabold text-lg lg:text-xl 2xl:text-2xl text-secondary">{{ $t('addition_title_first_number') }}</div>
                <div class="text-center font-extrabold text-sm lg:text-lg 2xl:text-lg text-secondary">{{ $t('addition_title_number_description') }}</div>

                <div class="flex justify-around mt-2 2xl:mt-4">
                    <div class="grid grid-cols-2 grid-rows-7 gap-y-1 2xl:gap-y-4 gap-x-4">
                        <Bg v-for="i in [1,2,3,4]" :key="i" @click="setMultiplier('first', i)"
                            class="w-12 h-12 cursor-pointer font-bold text-xl text-white rounded-full"
                            :border="first_multiplier.includes(i) ? 4 : 0">
                            {{ i }}
                        </Bg>
                    </div>
                </div>
            </div>

            <!-- second multiplier -->
            <div class="px-10 py-4 md:py-0">
                <div class="text-center font-extrabold text-lg lg:text-xl 2xl:text-2xl text-secondary">{{ $t('addition_title_second_number') }}</div>
                <div class="text-center font-extrabold text-sm lg:text-lg 2xl:text-lg text-secondary">{{ $t('addition_title_number_description') }}</div>
                <div class="flex justify-around mt-2 2xl:mt-4">
                    <div class="grid grid-cols-2 grid-rows-7 gap-y-1 2xl:gap-y-4 gap-x-4">
                        <Bg v-for="i in [1,2,3,4]" :key="i"  @click="setMultiplier('second', i)"
                            class="w-12 h-12 cursor-pointer font-bold text-xl text-white rounded-full"
                            :border="second_multiplier.includes(i) ? 4 : 0">
                            {{ i }}
                        </Bg>
                    </div>
                </div>
            </div>

            <!-- set time -->
            <div class="px-10 py-4 md:py-0">
                <div class="text-center font-extrabold text-lg lg:text-xl 2xl:text-2xl text-secondary">{{ $t('addition_title_time') }}</div>
                <div class="text-center font-extrabold text-sm lg:text-lg 2xl:text-lg text-secondary">({{ $t('addition_title_second') }})</div>
                <div class="flex justify-around mt-2 2xl:mt-4">
                    <div class="grid gap-1 2xl:gap-4">
                        <div class="flex items-center space-x-2" v-for="i in [40,50,60,70,80,90,100]" :key="i">
                            <Bg class="w-12 h-12 cursor-pointer font-bold text-white text-xl rounded-full"
                                :border="time == i ? 4 : 0"
                                @click="setMultiplier('time', i)">
                                {{ i }}
                            </Bg>
                            <div class="text-secondary font-bold text-sm lg:text-base 2xl:text-lg">
                                 {{ $t('addition_title_second') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-center items-center mt-5">
            <div class="text-xl font-bold cursor-pointer games-addition-bg-light text-white px-4 py-2 rounded-lg"
                 @click="setScreen('home')">
                {{ $t('addition_button_save') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import Bg from '../other/Bg.vue'

const emit = defineEmits(['screen', 'multiplier'])
const props = defineProps(['first_multiplier', 'second_multiplier', 'time', 'volume'])

const setScreen = (screen) => {
    emit('screen', screen)
}

const setMultiplier = (selected, number) => {
    emit('multiplier', {selected, number})
}
</script>
